module.exports = __webpack_public_path__ + "img/logo.5d83fbb4.svg";